import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@grid-ui/environment';
import { isNullOrUndefined } from '@maplecroft-typescript/utils';
import { FocalPointImage } from '../shared-models';

interface ImageResizerPipeOptions {
  proxyImageResizer: boolean;
  focalPoint?: FocalPointImage;
  imageWidth?: number;
  imageHeight?: number;
}

@Pipe({
  name: 'imageResizer',
  standalone: false,
})
export class ImageResizerPipe implements PipeTransform {
  private readonly imageResizerRegex = /^https:\/\/nessie-image-resizer(.(latest|test|staging))?.maplecroft.com/;

  public transform(value: string | undefined, options: Partial<ImageResizerPipeOptions> = {}): string {
    const { proxyImageResizer } = { proxyImageResizer: environment.proxyImageResizer, ...options };

    if (!value) {
      return '';
    }

    const result = `${value}?${this.getFocalPointParams(options).toString()}`;

    const regexMatch = result.match(this.imageResizerRegex);

    if (regexMatch) {
      const [_, gridEnvironment = ''] = regexMatch;

      let origin: string;

      if (proxyImageResizer) {
        origin = '';
      } else {
        origin = `https://grid${gridEnvironment}.maplecroft.com`;
      }

      return result.replace(this.imageResizerRegex, `${origin}/cms-assets`);
    }

    return result;
  }

  private getFocalPointParams(options?: Partial<ImageResizerPipeOptions>): URLSearchParams {
    const params = new URLSearchParams();

    const { focalPoint, imageWidth, imageHeight } = options ?? {};

    if (!focalPoint) {
      return params;
    }

    const { x, y, width, height } = focalPoint;

    if (isNullOrUndefined(x) || isNullOrUndefined(y) || isNullOrUndefined(width) || isNullOrUndefined(height)) {
      return params;
    }

    params.set('focal_point_x', String(x));

    params.set('focal_point_y', String(y));

    params.set('focal_point_width', String(width));

    params.set('focal_point_height', String(height));

    // Add image width and height if they are provided
    if (!isNullOrUndefined(imageWidth)) {
      params.set('width', String(imageWidth));
    }

    if (!isNullOrUndefined(imageHeight)) {
      params.set('height', String(imageHeight));
    }

    return params;
  }
}
